<template>
   <div :id="[newClass ? newId : 'checkout-contact-container']" :class="[isBorderavailable ? 'gts-box with-border' : '']">
      <div class="checkout-contact-header">
         <span class="section-title" v-show="isBorderavailable">{{ $t("checkoutContact_contactInformations") }} </span>
         <!--Flight Autofill wrapper -->
         <div id="autofill-actions-wrapper" v-if="isflight">
            <div id="autofill-wrapper">
               <button :class="{ active: !fillWithFirstPax }" @click="fillWithFirstPax = false">
                  {{ $t("checkoutContact_bntFillWithAgentInfo") }}
               </button>
               <button :class="{ active: fillWithFirstPax }" @click="fillWithFirstPax = true">
                  {{ $t("checkoutContact_bntFillWithFirstPaxInfo") }}
               </button>
            </div>
         </div>
      </div>

      <!--Flight Checkout Contact -->
      <div class="checkout-contact-wrapper">
         <div class="contact-input">
            <UISelectBox :label="$t('common_countryPhoneCode')" id="orderSelect" :options="CountryOptionList" v-model="contact.phone.country" allow-search has-icons />
         </div>
         <div class="contact-input">
            <UIInput
               v-model="contact.phone.city"
               custom-class="g-short-input"
               :placeholder="$t('common_city')"
               :label="$t('common_city')"
               v-input="{ type: 'numeric', len: [1, 4], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
         </div>
         <div class="contact-input">
            <UIInput
               v-model="contact.phone.number"
               :label="$t('common_phone')"
               :placeholder="$t('common_phone')"
               v-input="{ type: 'numeric', len: [3, 8], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
         </div>
         <div class="contact-input" v-if="isShowMail">
            <UIInput
               v-model="contact.email"
               :label="$t('common_email')"
               :placeholder="$t('common_email')"
               lowercase
               v-input="{ type: 'email', len: [3, 320], required: true, requiredMsg: $t('common_cannotBeEmpty') }" />
         </div>
         <div class="contact-input save-customer-wrapper" v-if="isflight && fillWithFirstPax">
            <button class="save-customer-btn" @click="SaveCustomer">
               <!-- <Icon name="save-01" /> -->
               <span>{{ $t("checkoutContact_btnUpdateFirstPax") }}</span>
            </button>
         </div>
      </div>

      <div class="transfer-info-text" v-if="identifier === 'transfer'">
         <Icon name="info-circle" />
         <span>{{ $t("checkoutContact_txtTransferInformationText") }}</span>
      </div>

      <div class="checkout-contact-information-wrapper" v-show="isflight">
         <p v-if="fillWithFirstPax">* {{ $t("checkoutContact_lblFilledWithFirstPaxInfos") }}</p>
         <p v-else>* {{ $t("checkoutContact_lblFilledWithAgentInfos") }}</p>
         <p>* {{ $t("checkoutContact_informationText") }}</p>
      </div>
   </div>
</template>

<script>
import debounce from "lodash.debounce";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";
import { customerService } from "@/service/index.js";
import Popup from "@/gts-popup.js";
export default {
   name: "CommonCheckoutContact",
   components: {
      UISelectBox,
      UIInput,
   },
   props: {
      isShowAutofill: Boolean,
      isRentaCar: Boolean,
      isBorderavailable: Boolean,
      isCustomClass: Boolean,
      newClass: String,
      newId: String,
      isShowMail: Boolean,
      isflight: Boolean,
      identifier: String,
   },
   data() {
      return {
         isThisFlight: this.isflight,
         fillWithFirstPax: false,
         defaultContact: {
            filled: false,
            email: null,
            phone: {},
         },
         countriesObj: [],
         phone: null,
         email: null,
         contact: {
            phone: {
               country: "+49",
               city: "",
               number: "",
               iso: "",
            },
            email: "",
         },
         customerList: [],
      };
   },
   created() {
      const self = this;
      if (this.isThisFlight) {
         customerService.listCustomers({ status: 1 }).then((res) => {
            self.customerList = res.customers;
         });
      }
   },
   computed: {
      CountryOptionList() {
         const self = this;
         return self.countriesObj;
      },
   },
   methods: {
      handlerUpdateContact: debounce(function () {
         if (this.isThisFlight) {
            this.$store.state.flight.checkout.request.contact.phone = this.phone;
            this.$store.state.flight.checkout.request.contact.email = this.email;

            this.contact.phone.country = this.phone.country;
            this.contact.phone.city = this.phone.city;
            this.contact.phone.number = this.phone.number;
            this.contact.email = this.email;
         }
      }),
      handlerFillWithFirstPax() {
         if (this.isThisFlight) {
            const paxInformations = this.$store.state.flight.checkout.request?.passengers[0];

            // Fihristten seçilmiş bir yolcu olup olmadığını kontrol et
            // Önce id kontrolü, yoksa name/surname ile fihristte ara
            const isInFihrist = this.checkCustomerInFihrist(paxInformations);

            if (paxInformations && isInFihrist && (paxInformations.phone || paxInformations.email)) {
               this.phone = paxInformations.phone;
               this.email = paxInformations.email;

               this.contact.phone.country = this.phone?.country || "+49";
               this.contact.phone.city = this.phone?.city || "";
               this.contact.phone.number = this.phone?.number || "";
               this.contact.email = this.email || "";
            } else {
               // Fihristte değilse inputları temizle
               this.contact.phone.country = "+49";
               this.contact.phone.city = "";
               this.contact.phone.number = "";
               this.contact.email = "";
            }
         }
      },
      checkCustomerInFihrist(paxInfo) {
         if (!paxInfo) return false;

         // Önce id kontrolü
         if (paxInfo.id != null && paxInfo.id > 0) {
            return true;
         }

         // Name ve surname yoksa fihristte olamaz
         if (!paxInfo.name || !paxInfo.surname) {
            return false;
         }

         // Name/surname ile fihristte ara
         const foundCustomer = this.customerList.find((customer) => {
            return customer.name?.toLowerCase() === paxInfo.name?.toLowerCase() && customer.surname?.toLowerCase() === paxInfo.surname?.toLowerCase();
         });

         return foundCustomer != null;
      },
      handlerFillWithAgentInfo() {
         if (this.isThisFlight) {
            // const paxInformations = this.$store.state.flight.checkout.request.contact;
            this.phone = this.defaultContact.phone;
            this.email = this.defaultContact.email;
         }
      },
      SaveCustomer() {
         const self = this;
         const firstPaxInformations = this.$store.state.flight.checkout.request.passengers[0];

         if (!firstPaxInformations) {
            Popup.warning(self.$i18n.t("common_warning"), "İlk yolcu bilgisi bulunamadı");
            return;
         }

         const customerData = {
            agencyId: this.$store.state.user.user.agencyId,
            agencyName: this.$store.state.user.user.agencyName,
            status: 1,
            gender: firstPaxInformations.gender,
            birthdate: firstPaxInformations.birthdate,
            name: firstPaxInformations.name,
            surname: firstPaxInformations.surname,
            email: this.contact.email || firstPaxInformations.email,
            phone: {
               iso: this.contact.phone.iso || firstPaxInformations.phone?.iso,
               country: this.contact.phone.country || firstPaxInformations.phone?.country,
               city: this.contact.phone.city || firstPaxInformations.phone?.city,
               number: this.contact.phone.number || firstPaxInformations.phone?.number,
            },
            nationality: firstPaxInformations.nationality,
            nationalIdentity: firstPaxInformations.nationalIdentity,
            passport: firstPaxInformations.passport,
            milesPan: firstPaxInformations.milesPan,
            hesCode: firstPaxInformations.hesCode,
            id: firstPaxInformations.id || 0,
            dbState: 1,
            insertedUserId: null,
            insertedUserEmail: null,
            insertedDatetime: null,
            updatedUserId: null,
            updatedUserEmail: null,
            updatedDatetime: null,
         };

         const messageKey = customerData.id === 0 ? "customerManagement_popupNewCustomerWillBeAdded" : "customerManagement_popupCustomerWillBeUpdated";
         const successKey = customerData.id === 0 ? "customerManagement_popupCustomerAddedSubtitle" : "customerManagement_popupCustomerEditSubtitle";

         Popup.confirm(self.$i18n.t("common_information"), self.$i18n.t(messageKey));
         self.$nextTick(() => {
            document.body.querySelector("#popup-ok").addEventListener("click", function () {
               customerService.setCustomer(customerData).then((response) => {
                  if (response.result.success) {
                     Popup.success(self.$i18n.t("common_success"), self.$i18n.t(successKey));
                  }
               });
            });
         });
      },
   },

   watch: {
      fillWithFirstPax: {
         handler: function (status) {
            if (this.isThisFlight) {
               if (status) {
                  this.handlerFillWithFirstPax();
               } else {
                  this.handlerFillWithAgentInfo();
               }
            }
         },
      },
      "$store.state.flight.checkout.request.passengers": {
         handler: function (passengers) {
            if (this.isThisFlight && this.fillWithFirstPax && passengers && passengers[0]) {
               this.handlerFillWithFirstPax();
            }
         },
         deep: true,
      },
      "$store.state.flight.checkout.request.contact": {
         handler: function (contact) {
            if (this.isThisFlight) {
               const self = this;
               self.phone = contact?.phone;
               self.email = contact?.email;

               if (!this.defaultContact.filled) {
                  this.defaultContact.email = contact?.email;
                  this.defaultContact.phone = contact?.phone;
                  if (contact?.email || contact?.phone) {
                     this.defaultContact.filled = true;
                  }
               }
            }
         },
         deep: true,
         immediate: true,
      },
      phone: {
         handler: function () {
            if (this.isThisFlight) {
               this.handlerUpdateContact();
            }
         },
         deep: true,
      },
      email: {
         handler: function () {
            if (this.isThisFlight) {
               this.handlerUpdateContact();
            }
         },
         deep: true,
      },
      contact: {
         handler: function (newValue) {
            let iso = this.CountryOptionList.find((item) => {
               return item.value == newValue.phone.country;
            });

            const rowObj = {
               city: newValue.city,
               email: newValue.email,
               number: newValue.number,
               phone: {
                  city: newValue.phone.city.numeric(),
                  country: newValue.phone.country,
                  number: newValue.phone.number,
                  iso: iso.icon.toUpperCase(),
               },
            };
            if (this.isThisFlight) {
               this.$store.state.flight.checkout.request.contact.phone = rowObj.phone;
               this.$store.state.flight.checkout.request.contact.email = rowObj.email;
            }
            this.$emit("update-to-contact", rowObj);
         },
         deep: true,
      },
      "$store.state.app.countryList": {
         handler: function (countries) {
            const self = this;

            countries.forEach((country) => {
               const rowObj = {
                  value: country.phoneCode,
                  name: `${country.phoneCode} (${country.nameTr})`,
                  icon: country.code,
               };
               self.countriesObj.push(rowObj);
            });
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss">
.dark-theme .transfer-info-text {
   background-color: var(--yellow-100) !important;

   span {
      color: var(--yellow-300) !important;
   }
}
</style>

<style lang="scss" scoped>
.checkout-contact-header {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 1rem;
}
#autofill-actions-wrapper {
   display: flex;
   align-items: flex-start;
   gap: 0.5rem;
   padding-bottom: 1rem;

   #autofill-wrapper {
      background: var(--gray-100);
      padding: 0.25rem;
      border-radius: 0.5rem;
      border: 1px solid var(--gray-300);
      display: flex;
      align-items: center;
      gap: 0.25rem;

      button {
         background: transparent;
         border: 1px solid transparent;
         border-radius: 0.375rem;
         padding: 0.35rem 0.75rem;
         cursor: pointer;
         font-weight: 500;
         color: var(--gray-600);
         font-size: 14px;
         white-space: nowrap;

         &:hover:not(.active) {
            background: var(--gray-200);
            color: var(--gray-800);
         }

         &.active {
            background: var(--gray-700);
            color: white;
            // border-color: var(--blue-600);
            box-shadow: 0 2px 4px rgba(109, 109, 109, 0.3);
         }
      }
   }
}

#checkout-contact-container {
   .checkout-contact-wrapper {
      display: flex;
      flex-direction: flex;

      @media (min-width: 576px) {
         display: grid;
         grid-template-columns: 1fr 0.75fr 1.25fr 1.25fr auto;
         width: 100%;
      }

      .contact-input {
         margin: 0 0.5rem;
         display: flex;

         @media (min-width: 576px) {
            margin-bottom: 0;
         }

         ::v-deep {
            .g-input-container {
               width: 100%;
            }
         }

         ::v-deep .form-item {
            input {
               position: relative;
               display: flex;
               justify-content: flex-start;
               align-items: center;
               border: 2px solid var(--gts-input-border);
               border-radius: 0.5rem;
               box-sizing: border-box;
               background: var(--gts-input-background);
               height: 48px !important;
               max-height: 100% !important;
               border-width: 2px;
               outline: transparent solid 2px;
               outline-offset: 2px;
               width: 100%;
               text-indent: 1rem;
               font-size: var(--normal);

               &.g-short-input {
                  width: 80px !important;
               }
            }
         }

         &.save-customer-wrapper {
            align-items: flex-end;

            @media (max-width: 575.98px) {
               width: 100%;
            }

            .save-customer-btn {
               background: var(--teal-500);
               border: none;
               border-radius: 0.5rem;
               padding: 0.75rem 1rem;
               cursor: pointer;
               display: flex;
               align-items: center;
               justify-content: center;
               gap: 0.5rem;
               height: 48px;
               white-space: nowrap;

               @media (max-width: 575.98px) {
                  width: 100%;
                  margin-top: 1rem;
               }

               &:hover {
                  background: var(--teal-600);
               }

               ::v-deep svg path {
                  stroke: white;
               }

               span {
                  color: white;
                  font-weight: 500;
                  font-size: 14px;
               }
            }
         }
      }
   }
   @media (max-width: 767.98px) {
      .checkout-contact-wrapper {
         display: block;
         .contact-input {
            display: block;
         }
      }
   }
   .checkout-contact-information-wrapper {
      margin-top: 2rem;
      margin-left: 0.5rem;
      p {
         font-size: var(--small);
         color: var(--gray-700);
      }
   }
   .transfer-info-text {
      display: inline-flex;
      align-items: flex-start;
      margin: 0 0.5rem;
      margin-top: 1.5rem;
      // margin-bottom: 1.5rem;
      background-color: var(--yellow-100);
      padding: 0.35rem 0.75rem;
      border-radius: 0.5rem;
      border: 1px solid var(--orange-200);
      gap: 0.5rem;

      ::v-deep svg {
         flex-shrink: 0;
         // min-width: 22px;
         // min-height: 22px;
         width: 20px !important;
         height: 20px !important;
      }
      ::v-deep svg path {
         stroke: var(--yellow-700) !important;
      }

      span {
         color: var(--yellow-800);
         font-size: var(--small);
         line-height: 1.35rem;
      }
   }
}
#rent-a-car-driver-informations-container {
   position: relative;
   .customer-management-wrapper {
      position: absolute;
      z-index: 99;
      width: 100%;
      border: 1px solid var(--gray-300);
      border-radius: 1rem;
      right: 0;
      /* box-shadow: var(--gray-800-alpha-75) 0px 50px 100px -20px, var(--gray-1000-alpha-75) 0px 30px 60px -30px; */
      box-shadow: var(--gts-box-shadow);

      @media (min-width: 992px) {
         width: 800px;
      }
   }
   .form-container {
      display: flex;
      flex-wrap: wrap;
      width: 90%;
      @media (max-width: 576px) {
         width: 100%;
      }

      .form-wrapper {
         width: 10%;
         margin-bottom: 1.25rem;

         @media (max-width: 576px) {
            width: 100%;
            padding: 0 !important;
         }

         ::v-deep {
            .g-input-container {
               .gts-input-wrapper {
                  input {
                     background: var(--gts-input-background);
                     border: 2px solid var(--gts-input-border);
                  }
               }
            }
         }

         &:last-child {
            width: 100%;

            textarea {
               width: 100%;
               height: 106px;
               background: var(--gts-input-background);
               border: 2px solid var(--gts-input-border);
               border-radius: 0.5rem;
               padding: 0.5rem 1rem;
            }
         }

         &.phone {
            display: flex;
            width: 100%;
            ::v-deep {
               .g-select-box-container {
                  width: 142px;
                  margin-right: 1rem;
               }
               .g-input-container {
                  &:last-child {
                     margin-left: 1rem;
                  }
               }
            }
         }
      }
   }
}
</style>
